import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import InfoPopup from '@/components/Popup/InfoPopup';
import {showToast} from '@/components/Toaster/Toaster';
import {getDeviceNameByType} from '@/services/device/deviceData';
import deviceStateService from '@/services/device/deviceStateService';
import appRouterService from '@/services/route/appRouterService';
import {setConnectionErrorAsRead} from '@/state/slices/mwSlice';
import {formatString} from '@/utils/stringUtils';

import useConnectionErrorContent from './useConnectionErrorContent';

const ConnectionError = ({deviceType}) => {
    const dispatch = useDispatch();
    const {popup, notificationTitle, notificationDescription} = useConnectionErrorContent() || {};
    const deviceName = getDeviceNameByType(deviceType);

    const eraseError = () => {
        dispatch(setConnectionErrorAsRead());
    };

    const handleError = () => {
        deviceStateService.clearDeviceState();
        eraseError();
    };

    const handlePrimaryButtonClick = () => {
        appRouterService.forwardToConnectionGuidePage(deviceType, true);
        handleError();
    };

    const onClose = () => {
        appRouterService.forwardToDevicesPage(true);
        handleError();
    };

    useEffect(() => {
        if (popup) return;
        if (notificationTitle || notificationDescription) {
            showToast(notificationTitle, {
                description: notificationDescription,
            });
            handleError();
            appRouterService.forwardToDevicesPage(true);
        }
    }, [notificationTitle, notificationDescription, popup]);

    if (!popup) return;

    const {icon, title, description, primaryButton, secondaryButton} = popup;

    return (
        <InfoPopup
            onClose={onClose}
            icon={icon}
            title={formatString(title, deviceName)}
            description={description}
            primaryButton={{
                ariaLabel: primaryButton?.alt,
                onClick: handlePrimaryButtonClick,
                text: primaryButton?.text,
            }}
            secondaryButton={
                secondaryButton
                    ? {
                          ariaLabel: secondaryButton.alt,
                          onClick: onClose,
                          text: secondaryButton.text,
                      }
                    : undefined
            }
        />
    );
};

export default ConnectionError;
